import React from "react";
//import IE11Detector from "../IE11/IE11Detector";
export default function MensajeWarning({mensaje}){
    //alert (JSON.stringify(mensaje));
    return <>
        <div className="btn-warning"><h1>{mensaje.data}</h1></div>
    </>
}